import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// import Http from "../../Http";
// import { Insurance_API } from "../../Helper";
import Http from "../../Http";
import { Insurance_API } from "../../Helper";
import { ShieldCheck, Clock, ArrowRight } from 'lucide-react'; // Lucide icons
import { motion } from 'framer-motion';
import {  Car, Shield, Zap } from "lucide-react";
import { Search, FileCheck,  SlidersHorizontal, ClipboardList, CheckCircle2, FileText } from "lucide-react";
import { CarFront, Wrench, Gem } from "lucide-react";
import { Calculator,  Layers, PlusCircle, IndianRupee } from "lucide-react";

import {
  AiOutlineSafety,
  AiOutlineCar,
  AiOutlinePlusCircle,
  AiOutlineFileProtect,
  AiOutlineSmile,
} from "react-icons/ai";
import {
  FaCarCrash,
  FaLock,
  FaFire,
  FaCloudSunRain,
  FaUserShield,
  FaBalanceScale,
  FaHeart,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";
import AddPageTest from "../AddPageTest";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const CarInsuranceNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const faqs = [
    {
      question: "What is car insurance?",
      answer:
        "Car insurance is a contract in which an insurance company agrees to cover certain costs associated with owning and driving a car. This can include coverage for accidents, theft, damage, and liability for injuries to others. It is designed to protect you from financial losses related to your vehicle.",
    },
    {
      question:
        "What factors should I consider when choosing a car insurance policy?",
      answer:
        "When selecting car insurance, consider factors like the types of coverage (liability, collision, comprehensive, etc.), deductible amounts, policy limits, and premium costs. You should also evaluate whether additional features like roadside assistance or rental car reimbursement are important to you, and check for any available discounts, such as multi-policy or safe driving discounts.",
    },
    {
      question: "Why is car insurance important?",
      answer:
        "Car insurance is important because it provides financial protection in the event of an accident, theft, or other damage to your vehicle. It also offers liability coverage to protect you from legal claims if you are responsible for injuring someone or damaging their property while driving. Without car insurance, you could face substantial financial burdens or legal consequences.",
    },
    {
      question: "Can I buy car insurance through TheFinMaster.com?",
      answer:
        "TheFinMaster.com is not a car insurance provider. We offer educational resources, policy comparison tools, and unbiased information to help you understand various car insurance options and choose the best policy for your needs. Once you have selected the right coverage, you will be directed to the insurance providers website to complete a secure application process.",
    },
    {
      question: "What is the difference between third-party and comprehensive car insurance?",
      answer:
        " Third-party insurance covers damages to other people or property caused by your car, which is mandatory by law. Comprehensive insurance covers both third-party liabilities and damages to your own vehicle due to accidents, theft, natural calamities, or fire.",
    },
    {
      question: "How is the premium for car insurance calculated?",
      answer:
        " Car insurance premiums are calculated based on factors like the car's make, model, age, location, fuel type, engine capacity, and claim history. Comprehensive policies also consider add-ons and declared insured value (IDV).",
    },
    {
      question: "What is a No Claim Bonus (NCB) in car insurance?",
      answer:
        " NCB is a reward given by insurers for not making any claims during the policy year. It translates into a discount on your renewal premium and increases with each claim-free year, up to a certain limit, making future policies more affordable.",
    },
    {
      question: "Can I transfer my car insurance when I sell my vehicle?",
      answer:
        " Yes, car insurance can be transferred to the new owner along with the vehicle. You need to notify the insurer, provide the sale documents, and request a policy transfer, which may involve an endorsement and change in ownership details.",
    },
    {
      question: "What is an IDV in car insurance?",
      answer:
        " IDV (Insured Declared Value) is the maximum amount the insurer will pay if your car is stolen or declared a total loss. It is based on the car’s current market value and decreases with depreciation each year, impacting your premium and claim amount.",
    },
    {
      question: "What documents are required to buy or renew car insurance?",
      answer:
        "To buy or renew car insurance, you typically need your car's registration certificate (RC), previous insurance details (if applicable), valid ID proof, and address proof. Some insurers may also request inspection in case of policy break.",
    },
    {
      question: "Are add-ons in car insurance worth it?",
      answer:
        " Add-ons like zero depreciation cover, roadside assistance, engine protection, and return to invoice can enhance your coverage. While they increase the premium, they offer additional peace of mind, especially for new or high-end cars.",
    },
    {
      question: "What is zero depreciation cover in car insurance?",
      answer:
        "Zero depreciation, or bumper-to-bumper cover, ensures you receive the full claim amount without any deduction for depreciation on car parts. It is ideal for new cars and helps reduce out-of-pocket expenses during repairs after an accident.",
    },
    {
      question: "Can I cancel my car insurance policy mid-term?",
      answer:
        "Yes, you can cancel your car insurance before its expiry. You must provide a valid reason and submit the required documents, like proof of new insurance or RC cancellation. Refunds are processed based on the unused policy period.",
    },
    {
      question: "How do I file a claim for car insurance?",
      answer:
        " To file a claim, contact your insurer immediately and provide details of the incident. Submit the required documents such as FIR (if needed), RC, driving license, and photos of the damage. The insurer will inspect and process your claim accordingly.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const featuresNew = [
    {
    icon: <Shield className="text-blue-600 w-10 h-10" />,
    title: "Third-Party Car Insurance",
    description: `
Most simple and basic type of motor insurance and is made compulsory under the Motor Vehicles Act, 1988.
This design provides for coverage against liability in the event of injury, death, or property damage suffered by a third party as a result of your vehicle.

However, it does not cover damages to your own car. Being a legal requirement, every car owner must at least possess a valid third-party insurance policy to drive on Indian roads.

**Ideal for:** Vehicle owners seeking basic legal compliance and protection against third-party liabilities.
`,
  },
  {
    icon: <CarFront className="text-blue-600 w-10 h-10" />,
    title: "Comprehensive Car Insurance",
    description: `
A Comprehensive Car Insurance policy offers all-around protection to cover both third-party liabilities as well as own damage losses.
It compensates against damages caused due to accidents, fire, theft, vandalism, or natural disasters like floods and earthquakes.

Under this policy, you also have an option to purchase add-on covers (like Zero Depreciation or Engine Protection) for further safety.
Although the comprehensive car insurance costs slightly more than third-party insurance, it gives a complete peace of mind for the car owners, and that is why it is favored by many.

**Ideal for:** Those desiring comprehensive protection for their cars not merely legal protection.
`,
  },
  {
    icon: <Wrench className="text-blue-600 w-10 h-10" />,
    title: "Standalone Own Damage Car Insurance",
    description: `
The Standalone Own Damage (OD) policy has been introduced by Insurance Regulatory and Development Authority of India (IRDAI) in 2019,
which allows you to insure your car only against own damage, unrelated to any third-party insurance.

So, if you have already secured a third-party policy, you may procure an OD policy from any insurer of your choice to protect your car against damages due to accidents, theft, or natural calamities.

**Ideal for:** Those who already have third-party insurance but want to protect their own vehicle against potential damages.
`,
  },
  {
    icon: <Gem className="text-blue-600 w-10 h-10" />,
    title: "Zero Depreciation Car Insurance Policy",
    description: `
Zero Depreciation Car Insurance Policy (commonly referred to as bumper-to-bumper cover) ensures that the claim amount is not subject to depreciation during repair or replacement of damaged vehicle parts.

Normally with aging, the value of car parts depreciates on account of wear and tear over time; this affects the claim settlement.
With this cover, your insurer pays you for the entire cost of the parts that were replaced, giving you maximum in terms of claim value and putting lesser burden on you in terms of out-of-pocket expenses.

**Ideal for:** New or luxury car owners who want complete coverage without worrying about depreciation costs.
`,
  },
];

  const cardsNew = [
    {
      title: "Accidental Damage",
      description:
        "Damage from road accidents, collisions, or overturning will be covered, thus paying for repairs or replacement of the vehicle.",
      icon: <FaCarCrash className="text-4xl text-red-500 mb-4" />,
    },
    {
      title: "Theft of the Vehicle",
      description: "In case of theft of the car, the policy provides compensation if it is not recovered, thereby indemnifying you against a complete financial loss.",
      icon: <FaLock className="text-4xl text-yellow-600 mb-4" />,
    },
    {
      title: " Fire and Explosion",
      description:
        "Loss/damage to the vehicle will be insured for any such accident due to fire or explosion or due to the self-ignition of the vehicle.",
      icon: <FaFire className="text-4xl text-orange-600 mb-4" />,
    },
    {
      title: "Natural Calamities",
      description:
        "Damage caused by natural disasters like floods, cyclones, earthquakes, landslides, or storms.",
      icon: <FaCloudSunRain className="text-4xl text-blue-500 mb-4" />,
    },
    {
      title: "Man-Made Disasters",
      description:
        "Offers indemnity for damages caused under riots, strikes, vandalism, or terrorism.",
      icon: <FaUserShield className="text-4xl text-green-600 mb-4" />,
    },
    {
      title: "Third-Party Liabilities",
      description:
"Covers any liability arising out of injury to or death of a third party or damage to property of a third party resulting from the insured vehicle.",      icon: <FaBalanceScale className="text-4xl text-purple-600 mb-4" />,
    },
     {
      title: " Personal Accident Cover",
      description:
"Provides protection for the owner-driver against bodily injury or death by accident, while in or elsewhere in the vehicle.",      icon: <FaHeart className="text-4xl text-purple-600 mb-4" />,
    },
  ];

 const points = [
  {
    title: "1️⃣ Visit a Trusted Insurance Platform or Company Website:",
    description: `Starting with a trusted insurance provider’s official website, or a credible comparison portal. Such a system allows you to view plans from several insurers at one place.`,
  },
  {
    title: "2️⃣ Enter Basic Vehicle Details:",
    description: `Provide basic details such as your car make, model, year of registration, fuel type, and city of registration. If renewing, enter previous policy details for a personalized quote.`,
  },
  {
    title: "3️⃣ Choose the Type of Policy:",
    description: `Third-Party Insurance, Comprehensive Cover, or a Standalone Own Damage Policy — depending on what you need and what you can afford.`,
  },
  {
    title: "4️⃣ Compare Premiums and Benefits:",
    description: `Options to compare premiums, limits of coverage, optional add-ons, and claim settlement ratios are many. This informs you of the policy that provides the best value for your money.`,
  },
  {
    title: "5️⃣ Add Suitable Add-Ons:",
    description: `Depending on your vehicle conditions and uses, enhance your coverage by adding add-ons such as Zero Depreciation, Engine Protection, Roadside Assistance, or No-Claim Bonus Protection.`,
  },
  {
    title: "6️⃣ Review Policy Terms Carefully:",
    description: `Read inclusions, exclusions, deductibles, and the claim process prior to making a payment for complete clarity.`,
  },
  {
    title: "7️⃣ Make Secure Online Payment:",
    description: `If satisfied, pay the premium by a secure online payment gateway through your mode of choice, be it debit or credit card, UPI, or Internet banking.`,
  },
  {
    title: "8️⃣ Download the Policy Instantly:",
    description: `After successful payment, the soft copy of your car insurance policy will get delivered to your email. You may also download it immediately from the insurer's website for future reference.`,
  },
  {
    title: "💡 Final Tip:",
    description: `Buying your car insurance online saves you plenty of time and is also an avenue for you to compare multiple insurers in a row; this guarantees that you have secured the best coverage available for the cheapest price.`,
  },
];
const points2 = [
  {
    title: "1️⃣ Visit the Insurer’s Official Website or a Comparison Portal:",
    description: `Get into your insurance provider’s website or a reputable online portal that permits the renewal of policies from multiple insurers all at once.`,
  },
  {
    title: "2️⃣ Enter Your Existing Policy or Vehicle Details:",
    description: `Input your car's registration number, prior policy number, and personal details. The system shall fetch your existing plan details along with calculating renewal options automatically.`,
  },
  {
    title: "3️⃣ Review Your Existing Coverage:",
    description: `You should also take this opportunity to evaluate the coverage you have in place. Upon any renewal, you can upgrade your plan from third-party to comprehensive, or include additional cover, such as Zero Depreciation or NCB Protection add-ons.`,
  },
  {
    title: "4️⃣ Check Your No Claim Bonus (NCB):",
    description: `If you have not put in any claims in the prior policy term, you should be getting yourself a No Claim Bonus. It needs to be ensured that this discount is given to your renewal premium, so you don’t lose out on an amount of money.`,
  },
  {
    title: "5️⃣ Compare Premiums and Add-Ons:",
    description: `If you intend to change insurers, comparing the plans from different companies beforehand will help you with your renewal. Many online portals give you the ability to see quotes side-by-side, thus assisting you in choosing a plan with better coverage at a lower premium.`,
  },
  {
    title: "6️⃣ Make the Renewal Payment Online:",
    description: `After going through your plan and confirming that it carries the right coverage, pay online through a debit/credit card, UPI, or net banking.`,
  },
  {
    title: "7️⃣ Download Your Renewed Policy Instantly:",
    description: `Upon a successful payment, an email will be sent to you with the renewed car insurance policy in it. This email will serve as proof of coverage, and feel free to download or print it for your records.`,
  },
  {
    title: "💡 Final Tip:",
    description: `Renewing your car insurance online saves time and eliminates the possibility of lapsing. Renewing also gives you flexibility with adjusting your coverage, adding benefits, and continuously providing protection to your vehicle.`,
  },
];
const points3 = [
  {
    title: "1️⃣ Inform Your Insurance Provider Immediately:",
    description: `Immediately after an accident, theft, or damage occurs, you will log onto your insurer's website or mobile app and report it. 
Early intimation would set into motion faster processing and avoid the rejection of the claims.`,
  },
  {
    title: "2️⃣ Fill Out the Online Claim Form:",
    description: `Provide the basic information like policy number, car registration number, date and time of the incident, and a brief description of what happened.`,
  },
  {
    title: "3️⃣ Upload Supporting Documents:",
    description: `Self-attest scanned copies or photographs of the documents required, like your driving license, RC book, policy copy, and FIR copy (whenever applicable). 
For minor accidents, image uploads of the damaged car may also be required.`,
  },
  {
    title: "4️⃣ Get Claim Intimation Number:",
    description: `Once the claim form and documents are submitted, the insurer will generate an intimation number or claim reference number. 
This must be maintained in a safe place for future reference on the claim's progress.`,
  },
  {
    title: "5️⃣ Vehicle Inspection:",
    description: `The surveyor may inspect the vehicle for damages by either physically going to the site or a video inspection for own damage claims. 
They then approve repair estimates based on their internal assessments.`,
  },
  {
    title: "6️⃣ Cashless or Reimbursement Claim:",
    description: `Cashless claim - When you get your car repaired from a network garage, the insurance company will directly settle the costs with the garage—you only pay for deductibles (if any). 
Reimbursement claim - You can see the repairs being done at non-network garages and can pay upfront for repairs to be reimbursed later by submitting final bills to the insurer.`,
  },
  {
    title: "7️⃣ Claim Settlement and Status Tracking:",
    description: `After completion of all verification, the insurance company would process the payment. 
You can also check the status of your claim online using your claim number through the insurer's portal.`,
  },
];
const points4 = [
  {
    title: "1️⃣ Car Insurance Policy Copy:",
    description: `A valid copy of your current car insurance policy serves as proof of coverage and helps the insurer identify your policy details and benefits.`,
  },
  {
    title: "2️⃣ Duly Filled Claim Form:",
    description: `This form contains all the essential details about the incident. Ensure it is filled accurately and signed by the policyholder before submission.`,
  },
  {
    title: "3️⃣ Vehicle Registration Certificate (RC):",
    description: `RC book certifies title of the vehicle and bears few important aspects such as registration number, chassis number, and engine number.`,
  },
  {
    title: "4️⃣ Valid Driving License:",
    description: `Valid driver license at the time of accident is required for making the claim under eligibility verification.`,
  },
  {
    title: "5️⃣ FIR (First Information Report):",
    description: `For injuries, damages to third parties, or theft cases, an FIR lodged at the local police station would be required.`,
  },
  {
    title: "6️⃣ Repair Estimates and Invoices:",
    description: `If your car is damaged, repair cost estimates or invoices from the garage should be submitted. This will help the insurer in their assessment and approval of the claim amount.`,
  },
  {
    title: "7️⃣ Photographs of the Damaged Vehicle:",
    description: `Clear photos of the damaged areas would remain evidence and facilitate verification during claim processing.`,
  },
  {
    title: "8️⃣ Original Keys (for Theft Claims):",
    description: `In case of vehicle theft, insurers may ask for both, original keys and a non-traceable certificate from the police, as the proof.`,
  },
  {
    title: "9️⃣ Discharge Voucher:",
    description: `Once the claim is sanctioned, a signed discharge voucher or satisfaction voucher will have to be executed to release the settlement amount.`,
  },
];

  const data = [
    ["Damages/Losses to own car due to an accident", false, true, true],
    ["Damages/Losses to own car in case of fire", false, true, true],
    ["Damages/Losses to own car in case of a natural calamity", false, true, true],
    ["Damages to Third-Party Vehicle", true, true, false],
    ["Damages to Third-Party Property", true, true, false],
    ["Personal Accident Cover", true, true, false],
    ["Injuries/Death of a Third-Party Person", true, true, false],
    ["Theft of your car", false, true, true],
    ["Customize your IDV", false, true, true],
    ["Extra protection with customized add-ons", false, true, true],
  ];


   const addOns = [
    {
      title: "Zero Depreciation Cover",
      description: `Depreciation lowers the value of car parts with the passage of time. Thus, the amount of the claim you receive is also lowered. With Zero Depreciation Cover, the insurance company does not deduct the depreciation cost of replaced parts at the time of claim settlement. This means that the entire claim amount for repairs or replacement will be given without imposing any depreciation loss on you — a recommended add-on for new or high-end cars.`,
    },
    {
      title: "No Claim Bonus (NCB) Protection Cover",
      description: `A No Claim Bonus (NCB) is a discount on the renewal premium granted to the policyholder for each claim-free year. But, the policyholder loses his NCB if he puts in even a single claim. NCB Protection Cover allows the policyholder to keep his NCB even if he makes a limited number of claims in the policy year. This ensures continued monetary savings on premium with far-reaching advantages.`,
    },
    {
      title: "Engine Protection Cover",
      description: `While a standard car insurance policy covers accidental damages, it usually excludes engine-related issues caused by oil leakage, water ingression, or mechanical breakdowns. Engine Protection Cover will cover you for the expensive engine repairs or replacement costs and is very useful for cars driven in flood-prone or water-logged areas.`,
    },
    {
      title: "Pay as You Drive Cover",
      description: `The Pay-As-You-Drive Cover enables you to pay premiums as per the actual usage of your car. Thus, if you rarely drive your car, this add-on ensures you will not have to pay the premium amount equal to that of a daily commuter. The method uses telematics or odometer readings to measure your distance and helps lift low-mileage car owners' burden of paying premiums and be safe.`,
    },
  ];

   const publicCompanies = [
    "The New India Assurance Company Limited",
    "National Insurance Company Limited",
    "United India Insurance Company Limited",
    "Oriental Insurance Company Limited",
  ];

  const privateCompanies = [
    "HDFC ERGO General Insurance Company Limited",
    "ICICI Lombard General Insurance Company Limited",
    "Bajaj Allianz General Insurance Company Limited",
    "Tata AIG General Insurance Company Limited",
    "Reliance General Insurance Company Limited",
    "SBI General Insurance Company Limited",
    "Go Digit General Insurance Limited",
    "ACKO General Insurance Limited",
  ];


   const steps1 = [
    {
      icon: <ShieldCheck className="text-blue-600" size={28} />,
      title: "1. Assess Your Coverage Needs",
      content:
        "If you drive occasionally and care predominantly about legal compliance, a Third-Party Car Insurance may be enough. But if you want protection against theft, fire, and accidental damages, then a Comprehensive Car Insurance Policy would be the way to go for complete protection. The right coverage depends also on the age, usage, location, and maintenance cost of your car. Your car’s age, usage, location, and maintenance cost also play a vital role in deciding the right coverage.",
    },
    {
      icon: <Search className="text-blue-600" size={28} />,
      title: "2. Compare Policies from Multiple Insurers",
      content:
        "One of the biggest advantages while going the internet way is that it empowers you to make side-by-side comparisons of policies. Insurance aggregator websites or the insurer’s portal can be visited to evaluate: Coverage inclusions and exclusions, Claim settlement ratio, Premium costs, Network garages, Add-on options. Comparing helps you find the most value-driven policy instead of settling for the first one you see.",
    },
    {
      icon: <SlidersHorizontal className="text-blue-600" size={28} />,
      title: "3. Check the Insured Declared Value (IDV)",
      content:
        "IDV defines your car's current market value and it impacts your premium and claim amount directly. Make sure the set IDV is correct; too low means lesser payout at claim time and too high may unnecessarily impact your premium.",
    },
    {
      icon: <FileCheck className="text-blue-600" size={28} />,
      title: "4. Look for Useful Add-Ons",
      content:
        "Enhancing your protection with Zero Depreciation Cover, Engine Protection, or No Claim Bonus Protection can come in handy. These small add-ons can really make a difference at claims stage and save you from huge repair expenses.",
    },
    {
      icon: <ClipboardList className="text-blue-600" size={28} />,
      title: "5. Review the Claim Settlement Process",
      content:
        "Compare the Claim Settlement Ratio (CSR) and reviews from customers of that insurer before you select them for coverage. Claims resolution will be faster and smoother with a company that has a high CSR coupled with a robust support system.",
    },
    {
      icon: <CheckCircle2 className="text-blue-600" size={28} />,
      title: "6. Evaluate Premium vs. Coverage",
      content:
        "Never select the cheap policy; cheap usually implies limited protection. Instead, look for the policy which provides balanced coverage, transparent pricing, and thorough benefits to guarantee your car safety and your financial security.",
    },
    {
      icon: <FileText className="text-blue-600" size={28} />,
      title: "7. Read the Policy Terms Carefully",
      content:
        "Before making payment, go through the policy wording to understand exclusions, deductibles, and claim procedures. It’s better to know the limitations upfront than face surprises during a claim.",
    },
  ];


 
  useEffect(() => {
    fetchInsuranceData();
  }, []);
  const fetchInsuranceData = async () => {
    try {
      const response = await Http.get(Insurance_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.insurance || response;

      // Filter the insurance data to show only Car category
      const carInsuranceData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Car")
        : [];

      setInsuranceData(carInsuranceData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch insurance data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  // const fetchInsuranceData = async () => {
  //     try {
  //         const response = await fetch('https://test.thefinmaster.com/console/react-app-directory/insurance-api.php');
  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }
  //         const data = await response.json();

  //         // Filter the insurance data to show only Car category
  //         const carInsuranceData = data.insurance.filter(insurance =>
  //             insurance.category_name === "Car"
  //         );

  //         setInsuranceData(carInsuranceData || []);
  //         setLoading(false);
  //     } catch (error) {
  //         setError('Failed to fetch insurance data');
  //         setLoading(false);
  //         console.error('Error fetching data:', error);
  //     }
  // };
  const features = [
    { icon: '🛡️', text: 'Reliable & Accurate Estimates' },
    { icon: '⏱️', text: 'Takes Less Than a Minute' },
    { icon: '📉', text: 'Instantly Shows Premium Breakup' },
    { icon: '📄', text: 'No Paperwork or Documentation' },
    { icon: '📲', text: ' Easy to Use on Any Device' },
    { icon: '💰 ', text: ' Helps You Save on Insurance' },

  ];


  const carinsurance = [
    {
      name: 'Maruti Suzuki ',
      path: '/maruti-suzuki-car-insurance',
      image: '/assets/suzukicar.png',
    },
    {
      name: 'Hyundai ',
      path: '/hyundai-car-insurance',
      image: '/assets/hondacar.png',
    },
    {
      name: 'Tata ',
      path: '/tata-car-insurance',
      image: '/assets/tatacar.png',
    },
    {
      name: 'Mahindra ',
      path: '/mahindra-car-insurance',
      image: '/assets/mahindracar.png',
    },
    {
      name: 'Nissan ',
      path: '/nissan-car-insurance',
      image: '/assets/nissan.png',
    },
    {
      name: 'Kia ',
      path: '/kia-car-insurance',
      image: '/assets/kiacar.png',
    },
    {
      name: 'Toyota ',
      path: '/toyota-car-insurance',
      image: '/assets/toyotacar.png',
    },
    {
      name: 'Skoda',
      path: '/skoda-car-insurance',
      image: '/assets/skoda.png',
    },
    {
      name: 'Mg ',
      path: '/mg-car-insurance',
      image: '/assets/mgcar.png',
    },
    {
      name: 'Honda ',
      path: '/honda-car-insurance',
      image: '/assets/hondaicon.png',
    },
    {
      name: 'Renault ',
      path: '/renault-car-insurance',
      image: '/assets/renaultcar.png',
    },
    
    {
      name: 'Volkswagen ',
      path: '/volkswagen-car-insurance',
      image: '/assets/volkswagencar.jpg',
    },
    
    
    
   
  ];
  const luxurycarinsurance = [
    {
      name: 'Mercedes Benz ',
      path: '/mercedes-benz-car-insurance',
      image: '/assets/mercedescar.png',
    },
    {
      name: 'BMW ',
      path: '/bmw-car-insurance',
      image: '/assets/bmwcar.png',
    },
    {
      name: 'Audi ',
      path: '/audi-car-insurance',
      image: '/assets/odicar.png',
    },
    {
      name: 'Volvo ',
      path: '/volvo-car-insurance',
      image: '/assets/volvocar.png',
    },
    {
      name: 'Lexus',
      path: '/lexus-car-insurance',
      image: '/assets/lexuscar.jpg',
    },
    {
      name: 'Jaguar Land Rover ',
      path: '/jaguar-land-rover-car-insurance',
      image: '/assets/jaguarcar.png',
    },
    {
      name: 'Porsche ',
      path: '/porsche-car-insurance',
      image: '/assets/porschecar.png',
    },
   
    
    
   
  ];
  
  return (
    <>
      <Helmet>
        <title>
        Compare Car Insurance in India – Instant Quotes & Online Policy
        </title>
        <meta
          name="description"
          content="Get the best car insurance quotes from top insurers in India. Compare, customize, and buy car insurance online instantly."
        />
        <meta
          name="keywords"
          content="auto insurance coverages, automobile insurance companies, commercial auto insurance, icici lombard motor insurance, maruti insurance online"
        />
        <link rel="canonical" href="https://thefinmaster.com/car-insurance" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
        <div className="w-full flex justify-center items-center px-4 mt-20">
        <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
        <AdBanner displayOrder="1" />
        </div>
      </div>
      {/* Your existing content */}
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li className="flex items-center">
            <span className="text-gray-500 ">Car Insurance</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h2 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-4 pl-6">
                  <span className="text-blue-600 ">Explore Car Insurance</span>{" "}
                  Options Now!
                </h2>
                <p className="text-lg md:text-base lg:text-lg  mt-4 pl-4">
          Choose from a variety of coverage options to tailor your car insurance
          plan to your specific needs. Protect yourself from third-party
          liabilities{" "}
        </p>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="../assets/clive.png"
                alt="Noimage"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          Choose from a variety of coverage options to tailor your car insurance
          plan to your specific needs. Protect yourself from third-party
          liabilities if you cause an accident, or safeguard your own vehicle
          against damage from collisions, theft, or natural disasters. Compare
          plans, understand coverage details, and get free quotes – all in one
          place. We'll help you find the perfect car insurance plan to ensure a
          smooth ride ahead.{" "}
        </p>
      </div> */}
      {/* <div className="bg-white py-12 px-6 sm:px-12 lg:px-24 shadow-md rounded-2xl max-w-4xl mx-auto mt-10">
      <div className="text-center space-y-4">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
          Estimate Your Car Insurance in Seconds
        </h2>
        <p className="text-gray-600 text-base sm:text-lg">
          Use our quick calculator to get an estimate of your car insurance premium instantly.
        </p>
        <Link
          to="/car-insurance-calculator" // Update this to your actual route
          className="inline-block mt-6 bg-blue-600 text-white text-lg px-6 py-3 rounded-full hover:bg-blue-700 transition"
        >
          Go to Calculator
        </Link>
      </div>
    </div> */}
  

      <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
        {/* Main content area with insurance listings */}
        <div className="w-full lg:w-3/4">
          <div id="insurance_plans" className="lg:pr-6 md:px-4 px-2">
            {loading ? (
              <div className="text-center py-10">Loading insurance options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : insuranceData.length === 0 ? (
              <div className="text-center py-10">
                No car insurance options available at the moment.
              </div>
            ) : (
              insuranceData.map((insurance) => (
                <div
                  key={insurance.id}
                  className="w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-2 md:gap-5 justify-between mx-auto mt-4"
                >
                  <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                    <Link to={`/car-insurance/${insurance.page_url}`}>
                      <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                        <img
                          className="w-full h-full object-contain"
                          alt={insurance.page_title || "Insurance Provider"}
                          src={insurance.image}
                        />
                      </div>
                    </Link>
                  </div>

                  <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Premium Starting </p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      @ ₹{insurance.premium_start}
                    </h4>
                  </div>

                  <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Claim Settlement </p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      {insurance.claim_settlement}%
                    </h4>
                  </div>

                  <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Network Garages</p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      {insurance.network_garages}+
                    </h4>
                  </div>

           <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                                <a
                      href={insurance.bank_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {/* <button className="bg-green-500 text-white font-semibold py-1 md:py-2 px-3 md:px-4 rounded hover:bg-green-600 transition duration-300 text-sm md:text-base"> */}
                                         <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">

                        Get Quote!
                      </button>
                    </a>

                    <Link to={`/car-insurance/${insurance.page_url}`}>
                      {/* <button className="text-white font-semibold py-1 md:py-2 px-3 md:px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500 text-sm md:text-base"> */}
                                       <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">

                      See Details
                      </button>
                    </Link>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Right side ad banner that scrolls with the page */}
        <div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            {/* <a href="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/niyoo.png" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
       
            <AdBanner displayOrder="2" />
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>
      {/* <div id="insurance_plans" className="lg:px-48">
        {loading ? (
          <div className="text-center py-10">Loading insurance options...</div>
        ) : error ? (
          <div className="text-center py-10 text-red-600">{error}</div>
        ) : insuranceData.length === 0 ? (
          <div className="text-center py-10">
            No car insurance options available at the moment.
          </div>
        ) : (
          insuranceData.map((insurance) => (
            <div
              key={insurance.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/car_insurance/${insurance.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={insurance.page_title || "Insurance Provider"}
                      src={insurance.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Premium Starting </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  @ ₹{insurance.premium_start}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Claim Settlement </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {insurance.claim_settlement}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Network Garages</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {insurance.network_garages}+
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={insurance.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/car_insurance/${insurance.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                    See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div> */}
{/* <AddPageTest/> */}
      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            What is a Car Insurance ?
          </h1>
          <p className="text-gray-600 leading-relaxed">
            Car insurance is an assurance financial cover plan, which protects you and your car against unforeseen losses/damages arising out of accidents, thefts, natural calamities, or sometimes third-party liability. This is simply defined as a safeguard against possible adverse conditions for your car and finances in case something unfortunate happens while on the road.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
          By buying a car insurance policy, you would pay a certain amount called a premium to the insurance company. In return for that, the insurance company would promise to pay against damages according to the terms and conditions and the coverage given in the policy.
          </p>
             <p className="text-gray-600 leading-relaxed mt-3">
According to the Motor Vehicles Act of 1988 of India, Third-party car insurance is mandatory under the vehicle whose ownership is proven. This type of insurance encompasses defining financial security for damage or injury to another person, vehicle, or property.          </p>
             <p className="text-gray-600 leading-relaxed mt-3">
For complete peace of mind, however, there is also Comprehensive Car Insurance, which insures against third-party liabilities and also offers protection against accidents, fire, theft, or acts of God for your own car.          </p>
        <p className="text-gray-600 leading-relaxed mt-3">
In brief, car insurance makes sure that on a trip, you do not have to brood over your vehicle, deep financial losses, or obligations that you might be expected to fulfill legally while on the road.          </p>
        </div>
      </div>
      <div className="p-4 sm:p-8 bg-white">
      <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
        Choose Your Car Brand
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
  {carinsurance.map((calc, index) => (
    <motion.div
      key={index}
      whileHover={{ scale: 1.04 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
    >
      <Link
        to={calc.path}
        className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[160px]"
      >
        <img
          src={calc.image}
          alt={calc.name}
          className="w-16 h-16 object-contain mb-2"
        />
        <span className="text-md font-medium text-gray-800 break-words leading-snug">
          {calc.name}
        </span>
      </Link>
    </motion.div>
  ))}
</div>
</div>
<div className="p-4 sm:p-8 bg-white">
      <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
        Choose Your Luxury Car Brands
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
  {luxurycarinsurance.map((calc, index) => (
    <motion.div
      key={index}
      whileHover={{ scale: 1.04 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
    >
      <Link
        to={calc.path}
        className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[160px]"
      >
        <img
          src={calc.image}
          alt={calc.name}
          className="w-16 h-16 object-contain mb-2"
        />
        <span className="text-md font-medium text-gray-800 break-words leading-snug">
          {calc.name}
        </span>
      </Link>
    </motion.div>
  ))}
</div>
</div>
      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Key Features of a Car Insurance Policy

        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2">
         There are many features included in car insurance policies that will help make car ownership not only financially secure but also convenient. Whether you own a new vehicle or have an old vehicle, each of these features has something to offer to maximize use of your cover and avoid unpleasant shocks when you come to claim.

        </p>

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🚗</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
              Financial Protection Against Loss or Damage
            </h2>
            <p className="text-gray-700 text-sm mt-1">
              Your insurance is responsible for expenses arising out of accidents, fire, theft, or natural calamities, such as floods, earthquakes, and storms. It also ensures that your hard-earned savings would remain untouched against any unanticipated emergencies.

            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🛡️</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
             Third-Party Liability Coverage
            </h2>
            <p className="text-gray-700 text-sm mt-1">
             As per Indian law, it is compulsory for every car owner to possess third-party insurance. It saves the owners from paying for damages or injuries to another person, vehicle, or property that might be caused by the insured car.

            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🧾</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
             Own Damage (OD) Cover
            </h2>
            <p className="text-gray-700 text-sm mt-1">
             This takes the form of an Own Damage protection for your car against accidents, natural disasters, vandalism, and damage while in transit.
            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">❤️</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
            Personal Accident Cover
            </h2>
            <p className="text-gray-700 text-sm mt-1">
Most car insurance policies will contain personal accident coverage for owner-drivers, providing protection against injury, disability, or accidental death.
            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏭</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
Network of Cashless Garages            </h2>
            <p className="text-gray-700 text-sm mt-1">
Insurers tie up with a wide network of authorized garages across the country, through which you can get your car repaired absolutely free at cash-like points since the payments would be settled directly between the insurer and the garage.
            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
            No Claim Bonus (NCB)
            </h2>
            <p className="text-gray-700 text-sm mt-1">
A no claim bonus is earned by a policyholder by not claiming any loss during the currency of the policy and provides a discount on renewal premiums. With the lapse of time without claiming any damages, the discount gets bigger and bigger.            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">➕</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
            Add-On Covers for Extended Protection
            </h2>
            <p className="text-gray-700 text-sm mt-1">
You can enhance your policy using such add-on covers as Zero Depreciation Cover, Engine Protection, and Road-side Assistance for comprehensive coverage.
            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💻</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
         Easy Online Management
            </h2>
            <p className="text-gray-700 text-sm mt-1">
From the purchase, renewals, and claims made on your policy, almost all carriers may, instead, offer fully digital services-to-be-fondest speedier, transparent and paper-free-in the process.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
     <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-18 lg:px-18 rounded-3xl shadow-lg max-w-6xl mx-auto mt-10">
      <div className="flex flex-col md:flex-row justify-between items-center gap-10">
        {/* Left - Text and CTA */}
        <div className="max-w-xl space-y-6 text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
            How to Calculate New Car Insurance <br />
            <span className="text-blue-600">Prices Online</span>
          </h2>
{/* 
          <p className="text-gray-700 text-lg">
            A Car Insurance Calculator is an online tool designed to help you
            calculate the estimated premium of your car insurance policy. By
            entering a few simple details about your vehicle — such as make,
            model, registration year, location, and desired coverage type — the
            calculator instantly displays your expected premium amount.
          </p> */}
          <p className="text-gray-700 text-lg">
  <a
    href="/financial-tools-calculators/car-insurance-calculator"
    className="text-blue-600 font-semibold hover:underline"
  >
    Car Insurance Calculator
  </a>{' '}
  is an online tool designed to help you calculate the estimated premium of your
  car insurance policy. By entering a few simple details about your vehicle — such as make,
  model, registration year, location, and desired coverage type — the calculator instantly
  displays your expected premium amount.
</p>

          <p className="text-gray-700 text-lg">
            Using Finmaster’s Car Insurance Calculator, you can easily check how
            different coverage types and add-ons affect your premium, allowing
            you to make an informed decision before purchasing.
          </p>

          <p className="text-gray-800 font-semibold text-lg">
            Calculate your Car Insurance Premium through Online Car Insurance
            Calculator.
          </p>

          <Link
            to="/financial-tools-calculators/car-insurance-calculator"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
          >
            Start Calculating <ArrowRight className="w-5 h-5" />
          </Link>
        </div>

        {/* Right - Feature List with Emojis */}
        <div className="space-y-4 text-left">
          {features.map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <span className="text-xl">{item.icon}</span>
              <span className="text-gray-800 font-medium">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

      <div className="max-w-7xl mx-auto px-6 py-6 text-center mt-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          Key Statistics on Car Insurance in India
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 max-w-3xl mx-auto">
          Car insurance premiums in India depend on various factors like vehicle
          type, driver profile, and location. Here are some essential insights:
        </p>

        <div className="mt-8 grid md:grid-cols-3 gap-8 text-left">
          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">1</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Vehicle Type & Insurance Costs:</strong> Third-party
              insurance premiums range from ₹4,000 to ₹15,000 annually,
              depending on the car type. Comprehensive coverage costs between
              ₹8,000 and ₹30,000, with SUVs generally having the highest
              premiums.
            </p>
          </div>

          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">2</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Driver Age & Premium Variation:</strong> Younger drivers
              (under 25) pay around ₹3,273 per year. Those aged 25-50 pay
              between ₹2,500 and ₹6,300, while drivers over 50 see premiums from
              ₹3,300 to ₹8,500.
            </p>
          </div>

          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">3</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Gender-Based Premium Differences:</strong> Female drivers
              generally pay lower premiums. On average, women pay ₹4,000-₹7,000
              for third-party insurance, while men pay between ₹8,000 and
              ₹12,000.
            </p>
          </div>
        </div>
      </div>
      {/* <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-gray-800">
                <th className="p-3 text-left border border-gray-300"></th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Third-Party
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Comprehensive
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Own Damage
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {[
                [
                  "Damages/Losses to own car due to an accident",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of fire",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of a natural calamity",
                  false,
                  true,
                  true,
                ],
                ["Damages to Third-Party Vehicle", true, true, false],
                ["Damages to Third-Party Property", true, true, false],
                ["Personal Accident Cover", true, true, false],
                ["Injuries/Death of a Third-Party Person", true, true, false],
                ["Theft of your car", false, true, true],
                ["Customize your IDV", false, true, true],
                ["Extra protection with customized add-ons", false, true, true],
              ].map(
                ([feature, thirdParty, comprehensive, ownDamage], index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="p-3 border border-gray-300">{feature}</td>
                    <td className="p-3 text-center border border-gray-300">
                      {thirdParty ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {comprehensive ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {ownDamage ? "✅" : "❌"}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div> */}
 <div className="max-w-7xl mx-auto px-4 py-6">
      {/* Mobile View (Stacked Cards) */}
      <div className="block md:hidden">
        {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
          <div
            key={index}
            className="border mb-4 p-4 rounded-lg bg-white shadow-md"
          >
            <h2 className="font-semibold text-gray-800 mb-2">{feature}</h2>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Third-Party:</span>
              <span>{thirdParty ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Comprehensive:</span>
              <span>{comprehensive ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Own Damage:</span>
              <span>{ownDamage ? "✅" : "❌"}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop View (Table) */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-[700px] w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100 text-gray-800">
              <th className="p-3 text-left border border-gray-300">Features</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Third-Party</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Comprehensive</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Own Damage</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
              <tr key={index} className="border border-gray-300">
                <td className="p-3 border border-gray-300">{feature}</td>
                <td className="p-3 text-center border border-gray-300">
                  {thirdParty ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {comprehensive ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {ownDamage ? "✅" : "❌"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      {/* <div className="bg-gray-200 px-4 py-10">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-2xl md:text-3xl text-center  font-semibold leading-7 text-primary-500">
            Types of Car Insurance Policies in India
          </h2>
          <p className="text-center text-gray-700 text-lg max-w-3xl mx-auto">
           Car insurance in India is structured to meet different needs and budgets of vehicle owners. Depending on the level of protection you wish to offer your car, several types of policies are available. Understanding these should conveniently place you for making an informed choice when purchasing or renewing a car insurance policy.

          </p>
          <ul className="mt-16 grid grid-cols-1 gap-6 text-center text-gray-700 md:grid-cols-3">
            {featuresNew.map((feature, index) => (
              <li
                key={index}
                className="rounded-xl bg-white px-6 py-8 shadow-sm hover:shadow-lg transition-shadow duration-300"
              >
                {feature.icon}
                <h2 className="my-3 font-medium">{feature.title}</h2>
                <p className="mt-1.5 text-sm leading-6 text-gray-600">
                  {feature.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
 <section className="bg-gray-100 py-16 px-4 md:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto text-center">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4">
          Types of Car Insurance Policies in India
        </h2>
        <p className="text-gray-700 text-lg max-w-3xl mx-auto leading-relaxed">
          Car insurance in India is structured to meet different needs and budgets of vehicle owners. Depending on the level of protection you wish to offer your car, several types of policies are available. Understanding these should conveniently place you for making an informed choice when purchasing or renewing a car insurance policy.
        </p>

        {/* Cards Grid */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresNew.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-md hover:shadow-lg transition-all duration-300 p-6 flex flex-col items-center text-center"
            >
              <div className="mb-4">{item.icon}</div>
              <h3 className="text-lg font-bold text-blue-900 mb-3">{item.title}</h3>
              <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line text-justify">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
      <div className="container mx-auto p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Coverages Under Car Insurance
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
        Before making any purchases under any car insurance scheme, it is important that you know what is covered in and excluded from the policy. Every car insurance policy has certain inclusions and exclusions, which impact your claim handling. It is advisable to be aware of these terms to avoid unforeseen surprises and ensure that the coverage is suitable to your requirements.

        </p>
          <h2 className="text-lg md:text-xl font-medium  text-gray-700 text-center">
        What is Covered in a Car Insurance Policy
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
A standard car insurance policy imparts financial protection to several risks and unforeseen events. The major coverage normally covers:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {cardsNew.map((card, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center"
            >
              {card.icon}
              <h2 className="text-lg font-semibold mb-2">{card.title}</h2>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
         What is Not Covered in a Car Insurance Policy
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2">
         There are exclusions under which an insurer will not pay for losses or damages although car insurance offers extensive protection. These exclusions would include some of the following:
        </p>

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚙️</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
             Regular Wear and Tear
            </h2>
            <p className="text-gray-700 text-sm mt-1">
Regular wear and tear comes under normal aging, mechanical breakdown of the car parts, etc.            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🚫 </span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
              Driving Without a Valid License
            </h2>
            <p className="text-gray-700 text-sm mt-1">
              Accidents where the driver doesn’t have a valid driving license are excluded from coverage.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🍺</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
             Drunk Driving or Intoxication
            </h2>
            <p className="text-gray-700 text-sm mt-1">
              Claims arising from accidents caused by the insured's being intoxicated or under the influence of drugs will be declared null and void.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚠️</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
              Consequential Damages
            </h2>
            <p className="text-gray-700 text-sm mt-1">
             This includes any indirect damages from an accident such as losing the engine after driving through water.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🔌</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
             Electrical or Mechanical Breakdown
            </h2>
            <p className="text-gray-700 text-sm mt-1">
              This excludes any damages from internal mechanical malfunctions or electrical breakdowns.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🌍</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
              Outside Geographical Limits
            </h2>
            <p className="text-gray-700 text-sm mt-1">
              If the vehicle travels outside the scope of defined geographical limits as in the policy (i.e., outside India), coverage ceases to be viable.
            </p>
          </div>
             <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🏁</span>
            <h2 className="text-lg font-semibold text-gray-800 mt-2">
            Use of Vehicle for Illegal or Commercial Purposes
            </h2>
            <p className="text-gray-700 text-sm mt-1">
Loss or damage occurring while the car is being used for illegal driving, unrepaired activities, or racing is excluded            </p>
          </div>
           
          
      </div>
  <p className="text-gray-700 text-lg mt-4">
Hence, making sure that you are fully aware of your policy’s inclusions and exclusions will help you make better decisions based on add-ons that you want, ensure right protection in place, and avoid later claims rejection.            </p>
    
        </div>
      <div className=" px-2 md:px-6 bg-gray-100 py-6">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 ">
            How to Buy Car Insurance Online
          </h2>
          <p className="text-gray-700 mb-6">
           The car insurance buying process has become so easy, transparent, and time-efficient that with a few clicks you can compare numerous policies, go through salient features, and select one optimal for your needs  with no paperwork or middlemen. This puts immense emphasis on convenience, quick decision-making, and secure transactions.
          </p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-2 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
           How to Renew Car Insurance Online
          </h2>
          <p className="text-gray-700 mb-6">
            Renewal of the car insurance policy requires just as much seriousness as the purchase itself. A valid insurance policy guarantees uninterrupted protection to your vehicle and makes you legally safe to drive. Vehicle insurance renewal can now be performed entirely online  in little time, in a secure way, and without paperwork.he premium of your car insurance depends on several crucial
            factors. Understanding these can help you make an informed decision
            and optimize your policy costs.
          </p>

          {points2.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

  <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
           How to Raise a Car Insurance Claim Online
          </h2>
          <p className="text-gray-700 mb-6">
            The act of claiming car insurance seems stressful, particularly following an accident of damage. This is made very easy and absolutely transparent with the introduction of online claim processes. With the introduction of most insurers towards digital processing of claims, anyone can easily report an incident, upload documents, and track a claim straight from home.
          </p>

          {points3.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
<div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
           Documents Required for Filing a Car Insurance Claim
          </h2>
          <p className="text-gray-700 mb-6">
Submission of the right documents is one of the most important steps in making your car insurance claim processable and claimable without delay. Keeping all the necessary papers ready will fast up the insurance decision process and, subsequently, discharge date.
          </p>

          {points4.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>


      <section className="py-10 px-6 md:px-12 bg-gradient-to-b from-white to-gray-100 text-gray-800">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <motion.h2
          className="text-2xl md:text-3xl font-semibold text-gray-800"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Car Insurance Add-On Covers
        </motion.h2>
        <motion.p
          className="text-gray-600 text-base md:text-lg leading-relaxed max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          A car policy affords you base coverage and may not cover the risk of every peril occurring to your vehicle. 
          This is where add-on covers come in. These benefits are optional extras that can be included in your policy 
          for additional protection, as a supplement per your needs and driving habits. They may add a little to your 
          premium, but they ensure maximum coverage and financial security during possible unforeseen instances.
        </motion.p>
        <motion.p
          className="text-gray-500 text-sm mt-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          Here are some of the most popular car insurance add-ons you can consider while purchasing or renewing your policy:
        </motion.p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {addOns.map((item, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-lg p-6 border border-gray-200 transition-all duration-300"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <h3 className="text-xl font-semibold text-blue-700 mb-2">
              {item.title}
            </h3>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              {item.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>



      <section className="py-10 px-6 md:px-12 bg-gradient-to-b from-white to-gray-100 text-gray-800">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <motion.h2
          className="text-2xl md:text-3xl font-semibold text-gray-800"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          List of Car Insurance Companies in India
        </motion.h2>

        <motion.p
          className="text-gray-600 text-base md:text-lg leading-relaxed max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          The insurance companies in India exhibit a plethora of reliable and
          attractive options for car insurance policies to meet the diverse
          customer requirement. These insurance companies are regulated by the
          Insurance Regulatory and Development Authority of India (IRDAI),
          guaranteeing transparency and credibility for the timely settlement of
          claims for their policyholders.
        </motion.p>

        <motion.p
          className="text-gray-500 text-sm mt-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Broadly, car insurance providers in India are divided into two
          categories — Public Sector Companies and Private Sector Companies.
          Let’s take a look at both:
        </motion.p>
      </div>

      {/* Public Sector Section */}
      <div className="max-w-6xl mx-auto mb-12">
        <motion.h3
          className="text-2xl font-semibold text-blue-700 mb-4"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          Public Car Insurance Companies
        </motion.h3>
        <motion.p
          className="text-gray-700 mb-6 leading-relaxed"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Public sector insurers are government operators, having a vast branch
          network, reliability, and customer service, all over India. They offer
          fairly competitive premiums and are extremely popular with customers
          who like attending traditional service channels.
        </motion.p>

        <motion.ul
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {publicCompanies.map((company, index) => (
            <li
              key={index}
              className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 p-4 text-center font-medium text-gray-700"
            >
              {company}
            </li>
          ))}
        </motion.ul>

        <p className="text-gray-700 leading-relaxed">
          These insurers have decades of experience and are recognized for their
          reliable claim settlement process and strong customer support.
        </p>
      </div>

      {/* Private Sector Section */}
      <div className="max-w-6xl mx-auto">
        <motion.h3
          className="text-2xl font-semibold text-blue-700 mb-4"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          Private Car Insurance Companies
        </motion.h3>

        <motion.p
          className="text-gray-700 mb-6 leading-relaxed"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Private insurers have brought in innovation, digital ease, and
          personalized service. Their focus is on prompt online issuance of
          policies, instant claim assistance, and tailor-made add-on options for
          the consumer.
        </motion.p>

        <motion.ul
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {privateCompanies.map((company, index) => (
            <li
              key={index}
              className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 p-4 text-center font-medium text-gray-700"
            >
              {company}
            </li>
          ))}
        </motion.ul>

        <p className="text-gray-700 leading-relaxed">
          These private insurers have redefined the car insurance experience by
          providing paperless procedures, app-based services, and flexible
          coverage options, thus simplifying and making the insurance process
          more accessible.
        </p>
      </div>
    </section>

     <section className="py-10 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6 text-center"
        >
          Car Insurance for Electric Cars ⚡
        </motion.h2>

        {/* Intro Paragraph */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-gray-700 text-lg leading-relaxed text-center mb-10"
        >
          Electric vehicles (EVs) are becoming immensely popular in India due to the
          green energy push by the government and sustainable mobility gaining ground.
          Like conventional cars, electric cars also need insurance coverage to be in
          legal compliance and financially secure against any shocks that await them.
        </motion.p>

        {/* Info Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-8 shadow-lg"
        >
          <div className="flex flex-col md:flex-row items-center md:space-x-10">
            {/* Icon */}
            <div className="flex justify-center mb-6 md:mb-0">
              <div className="p-6 bg-white rounded-full shadow-md">
                <Zap size={50} className="text-blue-600" />
              </div>
            </div>

            {/* Text Content */}
            <div>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Car insurance for electric cars, which is more like traditional motor
                cover but specially adapted to address the peculiar needs of the EV owner,
                provides coverage against damages, theft, accidents, and third-party
                liabilities, along with coverage for high-value components such as the
                battery pack, charging cables, etc., that are generally very expensive to
                repair or replace.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Types of Insurance */}
        <div className="mt-14">
          <motion.h3
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-2xl md:text-3xl font-semibold text-gray-800 text-center"
          >
            Types of Car Insurance for Electric Vehicles
          </motion.h3>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Third Party EV Insurance */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center space-x-3 mb-4">
                <Shield className="text-blue-600" size={28} />
                <h4 className="text-xl font-semibold text-gray-900">
                  Third-Party EV Insurance
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                As per the Motor Vehicles Act, it is mandatory for every electric car owner
                to have third-party insurance. This policy covers damages or injuries
                caused to another person or their property by your vehicle.
              </p>
            </motion.div>

            {/* Comprehensive EV Insurance */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center space-x-3 mb-4">
                <Car className="text-blue-600" size={28} />
                <h4 className="text-xl font-semibold text-gray-900">
                  Comprehensive EV Insurance
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                A comprehensive policy offers complete protection by covering both
                third-party liabilities and own-damage expenses. It includes coverage
                against accidents, fire, natural disasters, theft, and other unforeseen
                events.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>

     <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-14">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-semibold text-gray-900 mb-6 text-center"
        >
          How to Choose the Right Car Insurance Policy Online 🚗
        </motion.h2>

        {/* Intro Paragraph */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-gray-700 text-lg leading-relaxed text-center mb-12"
        >
          One of those choices that these days is most daunting is choosing the right car
          insurance policy since the market is flooded with hundreds of car insurance
          plans. The good news, however, is that online processes have made comparisons
          and purchasing of policies so simple and transparent. Online purchase of the
          right car insurance means understanding your needs, evaluating certain key
          factors, and then opting for a plan that will provide you with the best coverage
          at the right price.
        </motion.p>

        {/* Step-by-step Guide */}
        <div className="grid md:grid-cols-2 gap-8">
          {steps1.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="p-6 bg-gradient-to-r from-blue-50 to-teal-50 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center space-x-3 mb-4">
                {step.icon}
                <h4 className="text-xl font-semibold text-gray-900">{step.title}</h4>
              </div>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {step.content}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>


    
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CarInsuranceNew;
